import { useEffect, useRef, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Stack } from '@mui/material';
import { baseURL } from "../../../../config/api";
import { AllGateways } from "./AllGateways";

export const Gateways = () => {
    const navigate = useNavigate();
    const [isMenuShown, setIsMenuShown] = useState<boolean>(false);
    const [menuData, setMenuData] = useState<any[]>([]);
    const dropdownRef = useRef<HTMLUListElement>(null);
    const buttonRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (
                dropdownRef.current && !dropdownRef.current.contains(event.target) &&
                buttonRef.current && !buttonRef.current.contains(event.target)
            ) {
                setIsMenuShown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps

    }, []);

    useEffect(() => {
        fetch(`${baseURL}paymentGatewayMenus`)
            .then((res) => res.json())
            .then((data) => {
                const grouped = data.reduce(
                    (result: any[], item: any) => {
                        if (!result[item.region]) {
                            result[item.region] = [];
                        }
                        result[item.region].push(item);
                        return result;
                    },
                    {}
                );

                setMenuData(() =>
                    Object.keys(grouped).map((key) => {
                        return {
                            region: key,
                            provider: grouped[key],
                        };
                    })
                );
            })
            .catch((error) => {
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
            <div className="w-full bg-white p-4 rounded-md">
                <div className="flex items-center justify-end">
                    <div className="flex items-center gap-2.5">
                        <Stack spacing={1} direction="row">
                            <ul className="inline-block">
                                <li className="relative bg-transparent p-0 w-full">
                                    <button
                                        ref={buttonRef}
                                        className={`px-[8px] py-[6px] bg-primary rounded-lg border border-gray-300 text-white flex items-center gap-1.5 w-full`}
                                        onClick={() => setIsMenuShown(!isMenuShown)}
                                    >
                                        Add Gateway
                                        {isMenuShown ? (
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="20"
                                                height="20"
                                                viewBox="0 0 24 24"
                                                fill="#2f3739"
                                            >
                                                <path d="M7 14l5-5 5 5H7z" />
                                            </svg>
                                        ) : (
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="20"
                                                height="20"
                                                viewBox="0 0 24 24"
                                                fill="#2f3739"
                                            >
                                                <path d="M7 10l5 5 5-5H7z" />
                                            </svg>
                                        )}
                                    </button>

                                    <ul
                                        ref={dropdownRef}
                                        className={`absolute left-0 mt-2 bg-white border shadow-lg rounded-md z-10 w-full text-secondary`}
                                        style={{ display: isMenuShown ? 'block' : 'none' }}
                                    >
                                        {menuData.map((item: any, index: number) => (
                                            <li key={index} className="relative group">
                                                <div className="flex items-center justify-between px-4 py-2 hover:bg-gray-100 cursor-pointer">
                                                    <span className="text-sm">{item.region}</span>
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="18"
                                                        height="18"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke="#2f3739"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    >
                                                        <path d="M14 6l-6 6 6 6" />
                                                    </svg>
                                                </div>

                                                <ul className="absolute top-0 right-full mt-0 mr-1 w-48 bg-white border shadow-lg rounded-md hidden group-hover:block z-20">
                                                    {item.provider.map((value: any, idx: number) => (
                                                        <li
                                                            key={idx}
                                                            onClick={() =>
                                                                navigate('/admin/settings/payment-gateways-form', {
                                                                    state: { id: value.id, provider: value.provider },
                                                                })
                                                            }
                                                            className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm"
                                                        >
                                                            {value.provider}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </li>
                                        ))}
                                    </ul>
                                </li>
                            </ul>
                        </Stack>
                    </div>
                </div>

                <div>
                    <AllGateways />
                    <Outlet />
                </div>
            </div>
        </div>
    );
};
